import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, mergeVariableCategoryValues } from 'store/data/variables';

type HandlerInput = Parameters<typeof mergeVariableCategoryValues>[0];

export function useMergeVariableCategoryValues(): Operation<(input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(
		ActionTypes.MERGE_VARIABLE_CATEGORY_VALUES
	);

	function handler(input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(mergeVariableCategoryValues(input));
	}

	return [{ loading, error }, handler];
}
